import { combineReducers } from "redux";
import storeSlice from "./store.slice";
export default combineReducers({
  root:storeSlice
});